module.exports = "//public.getcloudapp.com/packs/media/images/infinite-3a7b7f1eba3ec1cb9ce009c5cc6d4038.svg";